import React from "react";

interface UploadIconProps {
  size?: number;
  color?: string;
}

const UploadIcon: React.FC<UploadIconProps> = ({
  size = 39,
  color = "#FFEF57",
}) => (
  <svg
    style={{
      userSelect: "none",
    }}
    width={size}
    height={(size * 31) / 39}
    viewBox="0 0 39 31"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_6088_9952)">
      <path
        d="M12.059 27.2823C10.539 27.3024 9.02326 27.2984 7.53707 26.8969C2.71537 25.6 -0.506127 21.047 0.0680857 16.3093C0.629632 11.68 4.36623 8.07045 9.1626 7.53645C9.42859 7.50834 9.47926 7.37986 9.54681 7.17911C10.8937 3.2203 13.7183 0.807268 18.0291 0.128729C23.1379 -0.674276 28.0778 2.38517 29.5387 7.14298C29.6274 7.42804 29.7498 7.51637 30.0454 7.56054C34.7699 8.24711 38.2997 11.684 38.9119 16.1728C39.655 21.5971 35.4117 26.7002 29.6696 27.198C28.0145 27.3426 26.3341 27.2743 24.6663 27.2703C23.9697 27.2703 23.4335 26.66 23.4546 26.0015C23.4757 25.3431 24.0288 24.8131 24.7466 24.8051C26.0512 24.793 27.3516 24.8051 28.6563 24.8011C32.3295 24.781 35.4159 22.4523 36.2772 19.0596C37.4299 14.5146 33.7904 10.0258 28.8716 9.93342C27.8541 9.91334 27.3938 9.53994 27.2123 8.58838C26.5494 5.07524 23.3237 2.50562 19.5702 2.49759C15.8083 2.48956 12.5614 5.03107 11.8774 8.52816C11.6621 9.61623 11.299 9.90933 10.1252 9.93342C6.2662 10.0177 2.92648 13.0129 2.61404 16.6666C2.28471 20.4929 4.96578 23.9579 8.82905 24.6364C9.64814 24.781 10.501 24.7729 11.337 24.797C12.287 24.8211 13.237 24.8011 14.187 24.8051C15.0441 24.8051 15.6394 25.319 15.6352 26.0537C15.6309 26.7845 15.0356 27.2823 14.1701 27.2864C13.465 27.2864 12.7599 27.2864 12.0548 27.2864L12.059 27.2823Z"
        fill={color}
      />
      <path
        d="M18.2481 14.1811C18.0792 14.3336 17.9821 14.418 17.8892 14.5063C16.6141 15.7188 15.339 16.9354 14.0597 18.1479C13.4601 18.714 12.6833 18.7462 12.1386 18.2322C11.5939 17.7223 11.6193 16.9715 12.2104 16.4054C14.3299 14.3858 16.4494 12.3663 18.5732 10.3548C19.1727 9.78462 19.9242 9.77659 20.5196 10.3427C22.656 12.3663 24.7839 14.3899 26.9119 16.4215C27.4819 16.9675 27.503 17.7143 26.9795 18.2202C26.4432 18.7381 25.6495 18.7181 25.0584 18.16C23.682 16.8591 22.314 15.5502 20.8531 14.161V14.6388C20.8531 19.5973 20.8531 24.5519 20.8531 29.5104C20.8531 29.7152 20.8447 29.928 20.7856 30.1207C20.6125 30.6949 20.0298 31.0562 19.4176 30.996C18.7927 30.9358 18.2945 30.4419 18.2481 29.8397C18.2396 29.7112 18.2481 29.5827 18.2481 29.4542C18.2481 24.5358 18.2481 19.6174 18.2481 14.699V14.1851V14.1811Z"
        fill={color}
      />
    </g>
    <defs>
      <clipPath id="clip0_6088_9952">
        <rect width="39" height="31" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default UploadIcon;
